<script setup lang="ts">
defineProps<{
  modelValue: boolean,
  title?: string,
}>();

const emit = defineEmits(["update:modelValue"]);
</script>

<template>

  <div class="flex items-start justify-between border-b dark:border-gray-700 bg-gray-50 dark:bg-gray-900 px-4 pb-2 pt-3.5">
    <div class="flex flex-col justify-start">

      <slot>
        <h1 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase">{{ title }}</h1>
      </slot>

    </div>
    <button class="flex">
      <UIcon
        name="i-mdi-close"
        class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
        @click="emit('update:modelValue', false)" />
    </button>
  </div>


</template>
